<template>
    <div class="control-chat">
        <PersistentMenu/>
        <div v-if="!disable_upload_file" id="box-upload-file" style="width: 30px;" class="ma-0">
            <v-file-input ref="fileInput"
                          accept=".jpg,.jpeg,.png,.gif,.xls,.xlsx,.doc,.docs,.pdf,.ppt,.pptx"
                          v-model="uploadFileContent"
                          label="Upload File" solo depressed
                          @click="fileInputClick"
                          @change="uploadFileClick">
            </v-file-input>
            <v-btn class="upload-btn" icon @click="$refs.fileInput.$refs.input.click()" :color="styles ? styles.primaryColor : '#6d9ccbff'">
                <v-icon>mdi-paperclip</v-icon>
            </v-btn>
        </div>

        <div class="chat-text-field">
            <div class="chat-text-field_container">
                <input
                   id="txt_input_message"
                   type="text"
                   :placeholder="styles.sendMessagePlaceholder"
                   name="new-password"
                   v-model="text_content"
                   @keypress.enter="sendMsg"
                   @change="check_suggest"
                   autocomplete="off"
                   maxlength="2000">
                <v-btn icon small :color="styles ? styles.primaryColor : '#6d9ccbff'" class="ml-1 btn-send" @click="sendMsg">
                    <v-icon>mdi-telegram</v-icon>
                </v-btn>
            </div>
        </div>
        <div v-if="displayFileUpload" class="box-file-upload" :title="fileName">
            <v-btn icon small depressed class="ma-0 pa-0" @click="deleteFileUpload">
                <v-icon>mdi-window-close</v-icon>
            </v-btn>
            <!-- <v-img
              src="https://picsum.photos/id/11/500/300"
              lazy-src="https://picsum.photos/id/11/10/6"
              aspect-ratio="1"
              class="grey lighten-2"
            ></v-img> -->
            <span>{{fileName}}</span>
        </div>
        <div class="box-suggest" v-if="can_suggest()">
            <span v-for="sgt, id in list_display_suggest" :key="id" @click="fill_suggest(sgt)" v-html="hightlight_keyword(sgt, text_content)">
            </span>
        </div>

        <v-snackbar
                v-model="snk_chat"
                bottom left
                :timeout="250000"
                color="error"
        >
            {{snk_message}}
            <v-btn
                    dark
                    text
                    @click="snk_chat = false"
                    icon
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import PersistentMenu from './PersistentMenu'
import handerMessage from '../business/handler_messages'
import handler_data from '../business/handler_data'
import { mapState } from 'vuex'
import { nextTick } from 'process'

export default {
    name      : 'ControlChat',
    components: {PersistentMenu},
    data() {
        return {
            text_content     : '',
            uploadFileContent: null,
            displayFileUpload: false,
            fileName         : '',
            acceptFiles      : ['jpg', 'jpeg', 'png', 'gif', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'pdf'],
            // snack bar
            snk_chat         : false,
            snk_message      : '',
            disable_upload_file: false,

            // suggestion
            allow_show_suggestion: false,
            show_suggest: false,
            click_suggest: false,
            is_chat_with_bot: false,
            list_display_suggest: [],
            list_suggest: [],
        }
    },
    mounted() {
        // console.log(this.uploadFileContent);        
        // disable_upload_file
        if (this.getUrlParam('disable_upload_file') && this.getUrlParam('disable_upload_file') == '1') {
            this.disable_upload_file = true;
        }

    },
    computed  : {
        ...mapState(['styles'])
    },
    watch: {
        text_content() {
            this.check_suggest()
        }
    },
    methods   : {
        hightlight_keyword(text, keyword) {
            let start_char = this.removeChar(text).indexOf(this.removeChar(keyword))
            let end_char = start_char + keyword.length

            let return_str = ''
            return_str = text.slice(0, end_char) + '</span>' + text.slice(end_char)
            return_str = return_str.slice(0, start_char) + '<span>' + return_str.slice(start_char)

            return return_str
        },
        fill_suggest(content) {
            this.click_suggest = true
            this.text_content = content
        },
        check_suggest() {
            if (!this.check_suggest) {
                return;
            }
            if (!this.can_suggest) {
                return;
            }
            if (this.click_suggest) {
                this.show_suggest = false
                this.list_display_suggest = []
                this.click_suggest = false
                return;
            }
            this.list_display_suggest = []
            if (this.text_content === '') {
                this.show_suggest = false
                this.list_display_suggest = []
            } else {
                this.list_suggest.forEach(sg => {
                    if (this.removeChar(sg).indexOf(this.removeChar(this.text_content)) >= 0) {
                        if (this.list_display_suggest.length < 4) {
                            this.list_display_suggest.push(sg)
                        }
                        
                    }
                })
            }
            // console.log(this.list_display_suggest)
            if (this.list_display_suggest.length > 0 ) {
                this.show_suggest = true;
            } else {
                this.show_suggest = false;
            }

        },
        // Convert to un-sign character
        removeChar(str) {
            str = str.toLowerCase();
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            return str;
        },
        getUrlParam(name, url) {
            if (!url) url = location.href
            name        = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            let regexS  = '[\\?&]' + name + '=([^&#]*)'
            let regex   = new RegExp(regexS)
            let results = regex.exec(url)
            return results == null ? null : decodeURIComponent(results[1])
        },

        async sendMsg() {
            if (this.text_content !== '') {
                // send to socket
                handerMessage.send_message_to_socket('text', this.text_content, this.$store.state.subChannel)

                // clear text field
                this.text_content = ''
            }

            // TODO - Upload file using button send
            // if (this.uploadFileContent !== null) {
            //   // upload file to server and send msg to socket
            //   // hide file
            //   // this.displayFileUpload = false;
            //   this.fileName = '';
            //   // upload file
            //   let fileUploadedName = await handerMessage.upload_file_to_server(this.uploadFileContent);

            //   let content = {
            //     "url": fileUploadedName
            //   }
            //   handerMessage.send_message_to_socket('upload_file', content);

            //   // clear file upload;
            //   this.uploadFileContent = null;
            // }
        },

        fileInputClick() {
            this.$refs.fileInput.$refs.input.value = ''
        },

        async uploadFileClick() {
            if (this.uploadFileContent) {
                // TODO: Validate File
                if (this.acceptFiles.indexOf(this.get_file_extention(this.uploadFileContent.name)) < 0) {
                    // Error
                    this.uploadFileContent = null
                    this.fileName          = ''
                    this.snk_message       = 'File type is not accept!'
                    this.snk_chat          = true
                    return false
                }

                // check file size > 10Mb
                if (this.uploadFileContent.size > 10485760) {
                    // Error
                    this.uploadFileContent = null
                    this.fileName          = ''
                    this.snk_message       = 'File size is over 10Mb!'
                    this.snk_chat          = true
                    return false
                }

                this.fileName = this.uploadFileContent.name

                // create msg uploading
                let newFileId = handler_data.guid()

                let msgUploading = {
                    '_id'       : newFileId,
                    type        : 'uploading',
                    source      : 1,
                    content     : {
                        'file_name': this.fileName,
                        'status'   : 'uploading'
                    },
                    created_time: (new Date()).toGMTString()
                }

                this.$parent.handler_messages(msgUploading)

                // send file to API BE
                let result_send_file = await handerMessage.upload_file_to_server(
                  this.$store.state.botCode,
                  this.$store.state.clientId,
                  this.$store.state.clientToken,
                  newFileId,
                  this.uploadFileContent,
                  this.$store.state.subChannel
                )
                if (result_send_file) {
                    // send success, remove uploading box
                    this.$parent.handler_message_uploading(newFileId, 0)
                } else {
                    this.$parent.handler_message_uploading(newFileId, 1)
                }
            }

        },

        deleteFileUpload() {
            // clear data upload
            this.uploadFileContent = null
            this.fileName          = ''
        },

        check_file_is_image(fileType) {
            if (fileType.indexOf('image/') >= 0) {
                return true
            } else {
                return false
            }
        },

        get_file_extention(fileName) {
            let p = fileName.toLowerCase().split('.')
            if (p.length > 1) {
                return p[p.length - 1]
            } else {
                return 'undefine'
            }
        },
        
        can_suggest() {
            if (this.show_suggest && this.$store.state.isChatWithBot) {
                return true
            } else {
                return false
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .v-input__prepend-outer {
        margin : 12px 1px 4px;
    }
    .v-input__control {
        display : none !important;
    }
    .box-file-upload {
        /* width: 70px; */
        /* height: 70px; */
        padding            : 5px 25px 5px 5px;
        border             : 1px solid #d3d3d3;
        position           : absolute;
        bottom             : 56px;
        left               : 5px;
        -webkit-box-shadow : 4px 4px 9px -4px rgba(0, 0, 0, 0.47);
        -moz-box-shadow    : 4px 4px 9px -4px rgba(0, 0, 0, 0.47);
        box-shadow         : 4px 4px 9px -4px rgba(0, 0, 0, 0.47);
        background-color   : #fff;
        max-width          : calc(100% - 10px);
        z-index            : 10000;
    }
    .box-file-upload span {
        display       : block;
        overflow      : hidden;
        /* max-width: calc(100% - 25px); */
        text-overflow : ellipsis;
        white-space   : nowrap;
    }
    .box-file-upload button {
        position : absolute;
        right    : 0;
        top      : 5px;
        width    : 20px;
        height   : 20px;
    }
    .box-file-upload button i {
        font-size  : 20px !important;
        margin-top : -1px;
    }
</style>

<style>
    #box-upload-file .v-input__control {
        display : none !important;
    }
    #box-upload-file .v-input__prepend-outer {
        display : none !important;
    }
    #box-upload-file .upload-btn {
        margin    : 6px 0 0 -7px;
        width     : 36px !important;
        max-width : 36px !important;
        height    : 36px !important;
    }
    .v-snack {
        bottom : 55px !important;
    }
    .v-snack .v-snack__content {
        padding    : 0 8px;
        min-height : 40px;
    }
    #txt_input_message::-webkit-input-placeholder {
        color   : inherit !important;
        opacity : .7 !important;
    }
    #txt_input_message::-moz-placeholder {
        color   : inherit !important;
        opacity : .7 !important;
    }
    #txt_input_message:-ms-input-placeholder {
        color   : inherit !important;
        opacity : .7 !important;
    }
    #txt_input_message:-moz-placeholder {
        color   : inherit !important;
        opacity : .7 !important;
    }

    
    .box-suggest {
        /* display: block; */
        position: fixed;
        font-size: 15px;
        /* padding: 5px; */
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: white;
        width: calc(100% - 24px);
        bottom: 60px;
        left: 12px;
        z-index: 100;
        color: #474747;
        overflow: hidden;
        box-shadow: 0px 0px 5px #c3c3c3;
    }

    .box-suggest > span {
        display: block;
        border-bottom: 1px solid #d3d3d3;
        padding: 10px;
        cursor: pointer;
    }

    .box-suggest > span:last-child {
        border-bottom: none;
    }

    .box-suggest > span:hover {
        background-color: #f2f2f2;
    }

    .box-suggest > span > span {
        font-weight: bold;
        /* color: mediumblue; */
    }
</style>
